import { useRecoilState } from "recoil";
import CategoryTitle from "../../components/CategoryTitle";
import Fade from "../../components/Fade";
import { selectionAtom } from "../../store/selection.atom";
import { visibilityAtom } from "../../store/visibility";

const PostsViewHeader = () => {
  const [selection] = useRecoilState(selectionAtom);
  const [{ showMainHeader }, setVisibility] = useRecoilState(visibilityAtom);

  return (
    <Fade
      isVisible={!!selection.category && !showMainHeader}
      onExitComplete={() => {
        setVisibility((prev) => ({
          ...prev,
          showCategories: true,
          showBlog: false,
          showMainHeader: true,
          showTitles: false,
        }));
      }}
    >
      <CategoryTitle />
    </Fade>
  );
};

export default PostsViewHeader;
